import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import {
  renderFormInputRow,
  renderFooterSubmitCancelButtons,
  renderFormInputRowName,
  renderSelectAccountDropdown,
  renderFormSelectOption,
  DeleteConfirmation,
} from '../../helpers/BuildHelperComponentV3';
import { useDeleteConfirmation } from '../../helpers/DeleteConfirmationUtils'; // Import the hook
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export const BuildExpensesCreditCardsComponent = (props) => {
  const {
    state,
    concatContent,
    allMenuItems,
    setLastStepInParent,
    isFormValid,
    formErrors,
  } = props;

  const moduleObject = {
    moduleTab: 'moduleDebt',
    mainTab: 'infoCreditCards',
    subTab: 'creditCards',
    countVal: 'numCC',
  };

  const { formDetails, isEditable, isAddNew } = state;

  const finalExistingItems = concatContent(
    moduleObject.moduleTab,
    moduleObject.mainTab,
    moduleObject.subTab
  );

  const defaultName =
    (formDetails &&
      formDetails[moduleObject.subTab] &&
      formDetails[moduleObject.subTab].name) ||
    '';

  // Use the delete confirmation hook
  const {
    isDeleteConfirmationOpen,
    openDeleteConfirmation,
    nameValidationError,
    setNameValidationError,
    closeDeleteConfirmation,
    handleDeleteConfirmation,
    nameToDelete,
  } = useDeleteConfirmation();

  useEffect(() => {
    if (isEditable || isAddNew) {
      setLastStepInParent(false);
    } else {
      setLastStepInParent(true);
    }
  }, [isEditable, isAddNew, setLastStepInParent]);

  return (
    <Typography>
      <div className="Select_account_main_outer" style={{ marginBottom: 10 }}>
        {renderSelectAccountDropdown(
          finalExistingItems,
          defaultName, 
          'Select Credit Card', 
          openDeleteConfirmation,
          props,
          state,
          moduleObject
        )}
      </div>
      {(isAddNew || isEditable) && (
        <div className="insured_main_outer">
          {renderFormInputRowName(
            'text',
            'tlName',
            'name',
            'Short name of card',
            'text',
            state,
            moduleObject,
            props,
            finalExistingItems,
            true,
            formErrors,
            isAddNew,
            isEditable
          )}
        </div>
      )}
      {(isAddNew || (finalExistingItems && finalExistingItems.length > 0)) && (
        <div className="insured_main_outer">
          {renderFormInputRow(
            'text',
            'tlBalance',
            'balance',
            'Current balance',
            'currency',
            moduleObject,
            state,
            props
          )}
          {renderFormInputRow(
            'text',
            'tlMonthlySpend',
            'monthlySpend',
            'Monthly Spend',
            'currency',
            moduleObject,
            state,
            props
          )}
          {renderFormInputRow(
            'text',
            'tlMonthlyPayment',
            'monthlyPayment',
            'Monthly payment (will be computed if left as zero)',
            'currency',
            moduleObject,
            state,
            props
          )}
          {renderFormInputRow(
            'text',
            'tlApr',
            'apr',
            'Annual percentage rate(APR)',
            'percentage',
            moduleObject,
            state,
            props
          )}
          {isAddNew || isEditable ? (
            <>
              {renderFormSelectOption(
                'text',
                'tlCompounding',
                'compounding',
                'Interest will compound',
                allMenuItems.compoundingMenuItems,
                moduleObject,
                state,
                props,
                true
              )}
            </>
          ) : (
            <>
              {renderFormInputRow(
                'text',
                'tlCompounding',
                'compounding',
                'Interest will compound',
                'textDropdown',
                moduleObject,
                state,
                props
              )}
            </>
          )}
          {renderFormInputRow(
            'text',
            'tlLimit',
            'limit',
            'Limit',
            'currency',
            moduleObject,
            state,
            props
          )}
          {/* {renderFormInputRow(
            'text',
            'tlGracePeriod',
            'gracePeriod',
            'Grace Period Days',
            'number',
            moduleObject,
            state,
            props
          )} */}
          {renderFooterSubmitCancelButtons(
            state,
            moduleObject,
            props,
            finalExistingItems,
            isFormValid
          )}
        </div>
      )}

      <div className="tab_main_nav">
        <div className="tab_left_nav">
          <button>
            <ArrowBackIcon /> Previous
          </button>
        </div>
        <div className="tab_right_nav">
          <button>
            Next <ArrowForwardIcon />
          </button>
        </div>
      </div>

      {/* Delete Confirmation Dialog */}
      {DeleteConfirmation(
        props,
        isDeleteConfirmationOpen,
        closeDeleteConfirmation,
        handleDeleteConfirmation,
        nameToDelete,
        moduleObject
      )}
    </Typography>
  );
};

export default BuildExpensesCreditCardsComponent;
